// Graphics-specific constants

export const GRAPHICS_SIDEBAR_ITEMS = [
  {
    key: "canvas",
    name: "Canvas",
  },
  {
    key: "old_posts",
    name: "Old Posts",
  },
  {
    key: "templates",
    name: "Templates",
  },
  {
    key: "calendar",
    name: "Calendar",
  },
];

// Graphics Game Group Constants
export const GAME_GROUP_SPACING = 20; // Spacing between game groups in pixels
export const MAX_GAME_COUNT = 3; // Maximum number of game groups allowed

export const GRAPHICS_NOT_ALLOWED_PAYLOAD_TYPES = ["custom_image"];

export const GRAPHICS_ALLOWED_MOVEMENT_PAYLOAD_TYPES = ["player_full_shot", "player_half_shot", "coach_image"];

export const GRAPHICS_ALLOWED_PREVIEW_IMAGE_PAYLOAD_TYPES = [
  "player_full_shot",
  "player_half_shot",
  "team_logo",
  "background_image",
  "coach_image",
];

export const GRAPHICS_TEMPLATE_KEY_ORDER = [
  "team_1_logo",
  "team_2_logo",
  "team_1_coach_image",
  "team_2_coach_image",
  "home_team",
  "away_team",
  "stats_group",
  "stats_item",
  "player_1_name",
  "player_2_name",
  "player_3_name",
  "player_4_name",
  "player_1_full_shot",
  "player_2_full_shot",
  "player_3_full_shot",
  "player_4_full_shot",
  "player_1_half_shot",
  "player_2_half_shot",
  "player_3_half_shot",
  "player_4_half_shot",
  "free_text",
  "sponsor_logo",
  "broadcaster_logo",
  "free_group",
  "game",
];

export const GRAPHICS_TEMPLATE_PLAYER_NAME_NAMETYPE_KEYS = ["full_name", "first_name", "last_name", "middle_name"];

export const GRAPHICS_IMAGE_DEFAULT_ASPECT_RATIOS = {
  background_image: "1_1",
  team_logo: "1_1",
  sponsor_logo: "1_1",
  broadcaster_logo: "1_1",
  coach_image: "4_5",
  player_full_shot: "9_16",
  player_half_shot: "1_1",
  team_shot: "1_1",
};
